// it is used for flash ansible product
const FILTERS = {
  "vsp-one-block-ansible": {
    hitachi_storage_ansible_module: {
      title: "VSP One Block Modules",
      iconClass: "network-wired",
    },

    ansible: {
      title: "Ansible",
      icon: "server.png",
    },
    python: {
      title: "Python",
      icon: "server.png",
    },
    gateway_os: {
      title: "Gateway OS",
      iconClass: "project-diagram",
    },
    uai_gateway: {
      title: "UAI Gateway",
      icon: "server.png",
    },
    array_customer_version: {
      title: "Storage",
      icon: "switch.png",
    },
  },
};
export default FILTERS;
